import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material"
import { MapManageTemplate } from "../../../components/Table/mapping-function/TableMapping";
import { PackageTable } from "../../../components/Table/component/PackageTable";
import { useEffect, useState } from "react";
import { EditIkn, FilterIkn, OffIkn, OnIkn, SearchIcon, ViewIkn } from "../../../utils/icon/Private-Pages/Icon";
import { useDispatch } from "react-redux";
import { setTemplateForView } from "../../../Slices/templateslice";
import { Link } from "react-router-dom";
import { setTemplateForCreate, setTemplateForEdit } from "../../../Slices/planslice";
import http from "../../../utils/http-common";
import { toast } from "react-toastify";


export const ManageTemplate = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [tableData, setTableData] = useState(MapManageTemplate([]));
    const [filter1, setFilter1] = useState(null);
    const [page, setPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [threedotss, setThreeDotss] = useState(true);
    const dispatch = useDispatch()
    useEffect(() => {
        getTemplate();
    }, [])
    const getTemplate = async () => {
            try {
                const response = await http.post(
                    "/master_service/admin/template/list"
                );
                const data = response.data.data.map((i) => ({
                    id: i.id,
                    template_id: i.template_id.toString(),
                    template_name: i.template_name,
                    created_by: i.created_by,
                    likes: i.likes,
                    downloads: i.downloads,
                    favourites: i.favourites,
                    template_cost: i.template_cost,
                    template_status: i.template_status,
                }));
                setTableData(MapManageTemplate(data));
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };
    const btns = [
        {
            title: ({ i, rowData }) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ViewIkn />
                        <Typography sx={{ pl: 1 }}>View Template</Typography>
                    </Box>
                );
            },
            fn: ({ index, i, rowData }) => {
                localStorage.setItem('templateId', rowData.id); 
            },
            cb: true,
            link: "/admin/view-template",
        },
        {
            title: ({ i, rowData }) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <EditIkn />
                        <Typography sx={{ pl: 1 }}>Edit Template</Typography>
                    </Box>
                );
            },
            fn: ({ index, i, rowData }) => {
                dispatch(setTemplateForEdit({ id: rowData.id, isEdit: true, isTemplate: true, table: false }));
            },
            cb: true,
            link: "/admin/new-template",
        },
                {
            title: ({ i, rowData }) => {
                return rowData.template_status?.props?.txt === "Deactivated" ?
                    (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <OnIkn />
                            <Typography sx={{ pl: 1 }}>Activate Template</Typography>
                        </Box>
                    )
                    :
                    (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <OffIkn />
                            <Typography sx={{ pl: 1 }}>Deactivate Template</Typography>
                        </Box>
                    );
            },
            fn: async ({ index, i, rowData }) => {
                try {
                    const response = await http.post('/master_service/admin/template/update', {
                        template_id: rowData.id,
                        status: rowData.template_status?.props?.txt === "Deactivated" ? "Active" : "Inactive"
                    });
                    
                    if (response.status === 200) {
                        toast.success(`Template ${rowData.template_status?.props?.txt === "Deactivated" ? "activated" : "deactivated"} successfully`);
                        getTemplate();
                    }
                } catch (error) {
                    console.error("Error updating template status:", error);
                    toast.error("Failed to update template status");
                }
            },
            cb: true,
            link: "",
        },
    ];
    useEffect(() => {
        dispatch(setTemplateForView({ id: 42, isView: true, table: false }));
    })

    const prop = {
        borderBoxStyle: { px: 0 },
        goto: true,
        filteredData: tableData,
        titleStyle: { fontSize: '20px', fontWeight: '600', color: '#000' },
        rowsPerPage,
        page,
        setPage,
        tableProps: { btnData: btns }, tableStyle: { Invoice: false, isThreeDot2: threedotss, OutBox: { borderRadius: "8px", borderBottomLeftRadius: 0, borderBottomRightRadius: 0, }, threeDot2: { textAlign: "end" }, },
    }
    return (
        <Box sx={{ width: '100%', }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography sx={{ color: '#000000', fontSize: '20px', fontWeight: '600' }}>Manage Template</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', border: '0.8px solid #797F8F80', borderRadius: '4px', padding: '0rem 1rem', width: '100%', height: '35px', maxWidth: '250px', }}>
                        <SearchIcon sx={{ color: '#757575', marginRight: '0.5rem' }} />
                        <TextField sx={{ flex: 1, '& .MuiOutlinedInput-root': { lineHeight: '35px', height: '35px', '& fieldset': { border: 'none', height: '35px', }, '&:hover fieldset': { border: 'none', }, '&.Mui-focused fieldset': { border: 'none', }, }, }} placeholder='Search...' variant='outlined' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </Box>
                    <Link to={'/admin/new-template'} onClick={() => { dispatch(setTemplateForCreate({ isTemplate: true })) }}>
                        <Button disableRipple sx={{ textTransform: 'capitalize', minHeight: 'max-content', minWidth: 'max-content', height: '26px', width: '64px', background: '#FF2800', color: '#fff', '&:hover': { background: '#FF2800' }, }}>+ New Template</Button>
                    </Link>
                </Box>
            </Box>
            <PackageTable prop={prop} />
        </Box>
    )
}